module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAABKklEQVR4AYySwUrDQBCGZzdpRAp9AKUogoWCRwVfosa36NWTByF2SiM+gELpUdG7AW8evXsRfIXixUNAI2Q3678N25qWlga+MDv7/8yfIZLwDHrJLciBWUF+BR3kNDGh6AZEO1rI+jLsfUHUhXZq8jPR+GLu/CzD3sPgg6nJ1mvj4q1tsMKKiZnlgJMx+P3H2Pat2DFvKoJNatVpY8uhqbEPE3bgLLT4TTqT2xnluw7P+27O5GU1P0lqMg/aFI8OUvqe2VR0lYONEfHJ4WU/bDuifnjELFbHi+OnZtxLRvgzUizj7pqf98pQs7ebpGombUF8Y3LxboTMPGGOIftURr+hP5QybeOsQLkIOEeY/4qGr6h2EHHn7IJPPyIOz2WgJmIEfJFCDKGhPwAAAP//L0PnSQAAAAZJREFUAwBtU6cjUvWPBQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list1.png
// module id = ymQM
// module chunks = 167